import React, { BaseSyntheticEvent, useEffect, useState, useRef, JSX } from "react";
import { useIntl } from "react-intl";
//import { useDispatch } from "react-redux";
import { Toast, ToastMessage } from 'primereact/toast'
import { Combobox, EInputTypes, GenericComboDTO, InputDate, InputTextCustom, RadioButtonGroup, RadioButtonGroupOption, ResponseDTO, generateGenericComboDTO, useFormValidation } from "medere-ui-framework";
import { ManagerFiscalDataDTO, initialStateManagerFiscalData } from "../../../interface/ManagerType";
import { YesNoENUM } from "../../../interface/interface";
import { Button } from "primereact/button";
import { useManagerService } from "../../../servicesHooks/Manager/useManagerService";
import FiscalAddressCombo from "../../../components/FiscalAddressCombo";
import { ComboDataDTO } from "../../../dto/ComboDataDTO";
import { useSupplierService } from "../../../servicesHooks/Supplier/useSupplierService";

/**
 * ManagerFiscalDataProps component props
 */
interface ManagerFiscalDataProps {
  medereentity: number;
  setBusinessname: (businessname: string) => void;
  setMedereentity: (medereentity: number|null) => void;
}

/**
 * ManagerFiscalDataProps component
 * @param {ManagerFiscalDataProps} props - component props
 * @returns {JSX.Element} - rendered component
 */
export default function ManagerFiscalData({ medereentity, setBusinessname, setMedereentity }: Readonly<ManagerFiscalDataProps>): React.ReactElement {
  const intl = useIntl();
  const { getAfipStatusByVatCustomerCategory } = useSupplierService();
  const { getManagerFiscalData, saveManagerFiscalData, updateManagerFiscalData, getcompmedicalservicestaxtype, getVatCustomerCategories } = useManagerService();
  //const dispatch = useDispatch()
  const [managerFiscalDataDTO, setManagerFiscalDataDTO] = useState<ManagerFiscalDataDTO>(initialStateManagerFiscalData);
  const { errors, setErrors, handleValidation } = useFormValidation(managerFiscalDataDTO);

  const toast = useRef<any>(null)
  const showMessage = (ref: React.RefObject<Toast>, msg: any, severity: ToastMessage['severity']) => {
    ref.current?.show({ severity: severity, summary: msg, life: 3000 });
  };

  const [fiscalAddress, setFiscalAddress] = useState<ComboDataDTO | null>(null)

  /**
   * Days array for combobox
   */
  const days = Array.from({ length: 31 }, (_, i) => ({ id: (i + 1).toString(), description: (i + 1).toString() }))


  /**
   * Yes/No options for combobox
   */
  const YesNoOptions: RadioButtonGroupOption[] = [
    { label: intl.formatMessage({ id: "Yes" }), value: 1 },
    { label: intl.formatMessage({ id: "No" }), value: 2 }
  ];

  useEffect(() => {
    if (medereentity > 0) {
      getManagerFiscalData(medereentity).then((data: ManagerFiscalDataDTO) => {
        data && setManagerFiscalDataDTO(data)
      })
    }
  }, [])

  useEffect(() => {
    setFiscalAddress({id:managerFiscalDataDTO.fiscaladdress, name:managerFiscalDataDTO.fiscaladdressdesc})
  }, [managerFiscalDataDTO])

  /**
   * Handles save button click
   */
  function handleUpdateSave() {
    managerFiscalDataDTO.medereentity = medereentity

    if (managerFiscalDataDTO.medereentityfiscaldata && managerFiscalDataDTO.medereentityfiscaldata > 0)
      updateManagerFiscalData(managerFiscalDataDTO).then((res: { data: ResponseDTO }) => {
        if (res.data.success)
          showMessage(toast, "Datos fiscales actualizados", 'success')
          //dispatch(setNotification({ typeOfNotification: ETypeOfNotification.INFO, desc: 'Datos fiscales actualizados' }))
        else
          showMessage(toast, "Error al actualizar los datos fiscales", 'error')
          //dispatch(setNotification({ typeOfNotification: ETypeOfNotification.ERROR, desc: 'Error al actualizar los datos fiscales' }))
      })
    else
      saveManagerFiscalData(managerFiscalDataDTO).then((res: { data: ResponseDTO }) => {
        if (res.data.success)
          showMessage(toast, "Datos fiscales guardados", 'success')
          //dispatch(setNotification({ typeOfNotification: ETypeOfNotification.INFO, desc: 'Datos fiscales guardados' }))
        else
          showMessage(toast, "Error al guardar los datos fiscales", 'error')
          //dispatch(setNotification({ typeOfNotification: ETypeOfNotification.ERROR, desc: 'Error al guardar los datos fiscales' }))
      });

  }

  function generateComboDataDTO(id:number, name:string):ComboDataDTO | null{
    if(!id || !name || id < 0)
      return null

    return {id, name}
  }

  return (<React.Fragment>
    <div className=' ml-3.5 flex align-items-baseline flex-column md:flex-row' >
      <InputTextCustom className="md:w-6 mr-0 md:mr-2"
        floatLabel label='CUIT' onChange={(e: BaseSyntheticEvent) => {
          setManagerFiscalDataDTO({ ...managerFiscalDataDTO, document: e.target.value })
          setErrors({
            ...errors,
            document: false
          })
        }} value={managerFiscalDataDTO.document}
        error={errors.document}
      />
      <InputTextCustom value={managerFiscalDataDTO.businessname} onChange={(e) => {
        setManagerFiscalDataDTO({ ...managerFiscalDataDTO, businessname: e.target.value })
        setErrors({
          ...errors,
          businessname: false
        })
        setBusinessname(e.target.value)
      }} label={"Razón Social "/*intl.formatMessage({ id: "BusinessName" })*/} error={errors.businessname} floatLabel className='md:w-6' />
    </div>
    <div className=" ml-3.5 flex flex-column md:flex-row align-items-baseline">
      <Combobox
        getItems={getVatCustomerCategories}
        optionLabel='name'//'categoryname'
        className="md:w-3 mr-0 md:mr-2"
        floatLabel
        label={"Categoría ante IVA"/*intl.formatMessage({ id: "VATCategory" })*/}
        setValue={(e: ComboDataDTO | null) => {
          setManagerFiscalDataDTO({ ...managerFiscalDataDTO, vatcategory: e ? (e.id? e.id : -1) : -1, vatcategorydesc: e ? (e.name? e.name : "") : "", afipstatus: -1, afipstatusdesc: "" })
          setErrors({
            ...errors,
            afipstatus: false,
            vatcategory: false
          })
        }} value={generateComboDataDTO(managerFiscalDataDTO.vatcategory, managerFiscalDataDTO.vatcategorydesc)}
        error={errors.vatcategory}
      />
      <Combobox
        label={"Estado frente a AFIP"/*intl.formatMessage({ id: "AFIPStatus" })*/}
        disable={!managerFiscalDataDTO.vatcategory || managerFiscalDataDTO.vatcategory == 3 || managerFiscalDataDTO.vatcategory == 6}
        reLoadItemsValue={{ selectedVatCategory: managerFiscalDataDTO.vatcategory }}
        floatLabel
        error={errors.afipstatus}
        className="md:w-3 mr-0 md:mr-2 mb-4 md:mb-0"
        getItems={getAfipStatusByVatCustomerCategory}
        params={{ vatCustomerCategory: managerFiscalDataDTO.vatcategory ?? -1 }}
        optionLabel='name' setValue={(e: ComboDataDTO | null) => {
          setManagerFiscalDataDTO({ ...managerFiscalDataDTO, afipstatus: e ? (e.id? e.id : -1) : -1, afipstatusdesc: e ? (e.name? e.name : "") : "" })
          setErrors({
            ...errors,
            afipstatus: false
          })
        }} value={generateComboDataDTO(managerFiscalDataDTO.afipstatus, managerFiscalDataDTO.afipstatusdesc)} />
      <Combobox
        error={errors.compmedicalservicestaxtype}
        className='w-6 md:w-3 mr-2'
        optionLabel='name'
        setValue={(e: ComboDataDTO | null) => {
          setManagerFiscalDataDTO({ ...managerFiscalDataDTO, compmedicalservicestaxtype: e?.id ?? -1, compmedicalservicestaxtypedesc: e?.name ?? "" })
          setErrors({ ...errors, compmedicalservicestaxtype: false })
        }}
        value={generateComboDataDTO(managerFiscalDataDTO.compmedicalservicestaxtype, managerFiscalDataDTO.compmedicalservicestaxtypedesc)}
        getItems={getcompmedicalservicestaxtype}
        floatLabel
        label={"Tipos de Prestaciones"/*intl.formatMessage({ id: "Benefits" })*/}
      />
    </div>

    <div className="ml-3.5">
      <FiscalAddressCombo fiscalAddress={fiscalAddress} onChange={(e: ComboDataDTO | null) => {
        setManagerFiscalDataDTO({ ...managerFiscalDataDTO, fiscaladdress: e?.id ?? -1, fiscaladdressdesc: e?.name ?? "" })
        setFiscalAddress(e)
        setErrors({ ...errors, fiscaladdress: false })
      }} medereentity={medereentity} error={errors.fiscaladdress} />
      
      <RadioButtonGroup
        error={errors.healthentitiesinvoicedseperated}
        className="align-items-center md:align-items-start w-4 my-2"
        classNameItem="center"
        options={YesNoOptions}
        orientation={`row`}
        itemWidth={25}
        label={"¿Facturar OOSS por separado?"}
        value={managerFiscalDataDTO.healthentitiesinvoicedseperated ? YesNoENUM.YES : YesNoENUM.NO}
        setValue={(valor: any) => {
          setErrors({ ...errors, healthentitiesinvoicedseperated: false })
          setManagerFiscalDataDTO({ ...managerFiscalDataDTO, healthentitiesinvoicedseperated: valor == YesNoENUM.YES })
        }
        }
        caption={errors.healthentitiesinvoicedseperated ? intl.formatMessage({ id: "Complete" }) : ''}
      />
    </div>

    {!managerFiscalDataDTO.healthentitiesinvoicedseperated && <React.Fragment>
      <div className="ml-3.5">
        <RadioButtonGroup
          error={errors.electroniccreditinvoice}
          className="align-items-center md:align-items-start w-4 my-2"
          classNameItem="center"
          options={YesNoOptions}
          orientation={`row`}
          itemWidth={25}
          label={"¿Requiere FCE?"}
          value={managerFiscalDataDTO.electroniccreditinvoice ? YesNoENUM.YES : YesNoENUM.NO}
          setValue={(valor: any) => {
            setErrors({ ...errors, electroniccreditinvoice: false })
            setManagerFiscalDataDTO({ ...managerFiscalDataDTO, electroniccreditinvoice: valor == YesNoENUM.YES })
          }
          }
          caption={errors.electroniccreditinvoice ? intl.formatMessage({ id: "Complete" }) : ''}
        />

        <RadioButtonGroup
          error={errors.requiresseparatedinvoices}
          className="align-items-center md:align-items-start w-4 my-2"
          classNameItem="center"
          options={YesNoOptions}
          orientation={`row`}
          itemWidth={25}
          label={"Separar facturas (exentas - gravadas)"}
          value={managerFiscalDataDTO.requiresseparatedinvoices ? YesNoENUM.YES : YesNoENUM.NO}
          setValue={(valor: any) => {
            setErrors({ ...errors, requiresseparatedinvoices: false })
            setManagerFiscalDataDTO({ ...managerFiscalDataDTO, requiresseparatedinvoices: valor == YesNoENUM.YES })
          }
          }
          caption={errors.requiresseparatedinvoices ? intl.formatMessage({ id: "Complete" }) : ''}
        />

        <RadioButtonGroup
          error={errors.mandatary}
          className="align-items-center md:align-items-start w-4 my-2"
          classNameItem="center"
          options={YesNoOptions}
          orientation={`row`}
          itemWidth={25}
          label={"Mandataria"/*intl.formatMessage({ id: "Mandatary" })*/}
          value={managerFiscalDataDTO.mandatary ? YesNoENUM.YES : YesNoENUM.NO}
          setValue={(valor: any) => {
            setErrors({ ...errors, mandatary: false })
            setManagerFiscalDataDTO({ ...managerFiscalDataDTO, mandatary: valor == YesNoENUM.YES })
          }
          }
          caption={errors.mandatary ? intl.formatMessage({ id: "Complete" }) : ''}
        />

        <div className=' flex align-items-baseline'>
          <p className='label'>{"Día del mes límite para presentar facturación"}: </p>
          <Combobox
            error={errors.limitpresentationday}
            optionLabel='description'
            className='ml-2 w-1'
            setValue={(e: GenericComboDTO | null) => {
              setManagerFiscalDataDTO({ ...managerFiscalDataDTO, limitpresentationday: e ? e.id : 0 })
              setErrors({ ...errors, limitpresentationday: false })
            }}
            value={generateGenericComboDTO(managerFiscalDataDTO.limitpresentationday, managerFiscalDataDTO.limitpresentationday.toString())}
            list={days}
          />
        </div>

        <div className=' flex align-items-baseline'>
          <p className='label'>{"Vencimiento de facturas a partir de la fecha de emisión"}: </p>
          <InputTextCustom className="w-1 mx-2" value={managerFiscalDataDTO.invoiceduedays.toString()} keyfilter={"num"} onChange={
            (e) => {
              let isNumber = !isNaN(parseInt(e.target.value))

              setErrors({ ...errors, invoiceduedays: false })
              setManagerFiscalDataDTO({ ...managerFiscalDataDTO, invoiceduedays: isNumber ? parseInt(e.target.value) : 0 })
            }} error={errors.invoiceduedays} />
          <p className="label">{" días"}</p>

          <RadioButtonGroup
            error={errors.businessdays}
            className="align-items-center md:align-items-start w-4 my-2"
            classNameItem="center"
            options={[{ label: 'hábiles', value: 1 }, { label: 'corridos', value: 2 }]}
            orientation={`row`}
            itemWidth={25}
            value={managerFiscalDataDTO.businessdays ? YesNoENUM.YES : YesNoENUM.NO}
            setValue={(valor: any) => {
              setErrors({ ...errors, businessdays: false })
              setManagerFiscalDataDTO({ ...managerFiscalDataDTO, businessdays: valor == YesNoENUM.YES })
            }
            }
            caption={errors.businessdays ? intl.formatMessage({ id: "Complete" }) : ''}
          />
        </div>
      </div>
    </React.Fragment>}



    <p className=" ml-3.5 primary font-medium mt-4">IIBB Arba</p>
    <div style={{maxWidth:'65%'}} className=" ml-3.5 flex flex-column md:flex-row align-items-end">
      <InputTextCustom
        floatLabel
        label="N° de IIBB"
        onChange={(e: BaseSyntheticEvent) => {
          setManagerFiscalDataDTO({ ...managerFiscalDataDTO, iibb: e ? e.target.value : "" })
        }}
        className="mr-0 md:mr-2"
        value={managerFiscalDataDTO.iibb}
      ></InputTextCustom>
      <InputTextCustom
        inputType={EInputTypes.NUMBER}
        minFractionDigits={2}
        className="mr-0 md:mr-2"
        floatLabel
        locale={intl.locale}
        label={"% de exclusión"/*intl.formatMessage({ id: "ExclusionPercentaje" })*/}
        onChange={(e: BaseSyntheticEvent) => {
          setManagerFiscalDataDTO({ ...managerFiscalDataDTO, iibbExclusionPercentage: e ? e.target.value : 0 })
        }}
        value={managerFiscalDataDTO.iibbExclusionPercentage}
      ></InputTextCustom>
      <InputDate
        className="mr-0 md:mr-2"
        value={managerFiscalDataDTO.iibbFromDate ? new Date(managerFiscalDataDTO.iibbFromDate) : null}
        onChange={(e: BaseSyntheticEvent) => {
          setManagerFiscalDataDTO({ ...managerFiscalDataDTO, iibbFromDate: e ? e.target.value?.getTime() : null })
        }}
        floatLabel
        label={intl.formatMessage({ id: "From" })}
      ></InputDate>
      <InputDate
        floatLabel
        label={intl.formatMessage({ id: "to" })}
        value={managerFiscalDataDTO.iibbToDate ? new Date(managerFiscalDataDTO.iibbToDate) : null}
        onChange={(e: BaseSyntheticEvent) => {
          setManagerFiscalDataDTO({ ...managerFiscalDataDTO, iibbToDate: e ? e.target.value?.getTime() : null })
        }}
      ></InputDate>
    </div>

    <div className=' ml-3.5 flex flex-row justify-content-end'>
      <Button className="buttonMain2" label={intl.formatMessage({ id: "Cancel" })} onClick={() => {
        setMedereentity(null)
        //window.history.back()
      }} />
      <Button className='buttonMain' label={intl.formatMessage({ id: "Save" })} onClick={() => {
        let _errors = { ...errors }
        if (managerFiscalDataDTO.limitpresentationday <= 0)
          _errors.limitpresentationday = true

        if (managerFiscalDataDTO.healthentitiesinvoicedseperated){
          handleValidation(handleUpdateSave, _errors, ['medereentityfiscaldata', 'invoiceduedays', 'iibb', 'iibbFromDate', 'iibbToDate', 'medereentity', 'mandatary', 'businessdays', 'limitpresentationday', 'electroniccreditinvoice', 'requiresseparatedinvoices'])
        }else {
          handleValidation(handleUpdateSave, _errors, ['medereentityfiscaldata', 'iibb', 'iibbFromDate', 'iibbToDate', 'medereentity'])
        }
        }} />
    </div>

  </React.Fragment>
  )
}
